import { joinClasses } from 'utils/joinClasses'
import { Typography } from '@frontend/design_system'
import { ToggleButtonProps } from './types'
import styles from './styles.module.scss'

export const ToggleButton = ({
  value,
  selected,
  onClick,
  children,
}: ToggleButtonProps) => (
  <Typography
    className={joinClasses(styles.button, [styles.selected, selected])}
    onClick={() => onClick?.(value)}
    name={selected ? 'body2WMedium' : 'body2WRegular'}
    color={selected ? 'blackMaster' : 'grey600'}
    dataTestId={`toggle-button-${value}`}
  >
    {children}
  </Typography>
)
